export type Block =
  | { type: 'p'; text: string }
  | { type: 'h'; text: string }
  | { type: 'q'; text: string; by?: string }
  | { type: 'list'; items: string[] };

export interface Article {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  date: string;
  readTime: string;
  author: string;
  tags: string[];
  views: number;
  featured?: boolean;
  cover: string;
  coverAlt: string;
  body: Block[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: '九十年代选秀爆冷出局：当年最被看好的那位，后来去哪了',
    category: '陈年旧瓜',
    excerpt:
      '那年总决赛所有人都笃定冠军非他莫属，现场却爆出了让直播间集体沉默的结果。二十年后再回看，那场"出局"背后其实藏着整套早已写好的剧本。',
    date: '2025-08-12',
    readTime: '8 分钟',
    author: '档案员·阿菁',
    tags: ['选秀考古', '旧访谈', '翻车现场'],
    views: 42800,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=1990s%20Chinese%20variety%20talent%20show%20final%20stage%20with%20spotlights%20and%20old%20TV%20cameras%2C%20candid%20archival%20entertainment%20press%20photograph%2C%20warm%20aged%20sepia%20film%20grain%2C%20nostalgic%20glow%2C%20retro%20concert%20lighting%2C%20no%20text&width=960&height=640&seq=gossip-cover-01&orientation=landscape',
    coverAlt: '九十年代选秀总决赛舞台旧照',
    body: [
      { type: 'p', text: '如果时间倒回那个夏天的总决赛之夜，几乎没有人会把"黑马爆冷"四个字和当晚的进程联系起来。票数一路领先、媒体一致看好的那位选手，却在大众评审环节被一道突如其来的加减分打乱了节奏。' },
      { type: 'p', text: '事后复盘，节目组的赛制在最后一轮临时加入了"现场导师追加分"，而追加分的分配规则直到直播前两分钟才在导播间被敲定。当年的观众并不知道，从赛制设计到话题营销，每一步都对应着一份收视率 KPI。' },
      { type: 'h', text: '那声沉默背后的产业逻辑' },
      { type: 'p', text: '选秀从来不只是才艺比拼，它更是一场关于"谁能成为下一个流量符号"的产业推演。当年被淘汰的那位，恰好不在品牌方拟定的代言画像里；而最终夺冠者，则被安排了一条从专辑到影视的完整出道路线。' },
      { type: 'p', text: '有意思的是，多年后那位被"出局"的选手接受旧访谈时只是淡淡回应："那时候我们都还太年轻，把比赛看得太重，后来才明白那只是一道题目。"这句话，恰恰是理解那场旧瓜最好的钥匙。' },
      { type: 'q', text: '比赛结束了，讨论才真正开始——真正值得被重读的，从来不只是胜负，而是胜负背后那套看不见的手。', by: '编者按' },
      { type: 'p', text: '把镜头再拉远一点：那一年的选秀热潮，实际上开启了中国电视综艺此后十余年的流量竞赛。今天的很多"考古梗"，都能在那场比赛的赛制细节里找到最初的影子。' },
    ],
  },
  {
    id: 2,
    title: '那场被误解多年的颁奖礼"黑脸"，原来是因为座位牌贴反了',
    category: '考古重读',
    excerpt:
      '一张广为流传的"黑脸生图"让某位艺人被贴上耍大牌标签近十年。可当我们逐帧回看当晚的机位原片，才发现真相和舆论想象差了十万八千里。',
    date: '2025-09-01',
    readTime: '6 分钟',
    author: '资料员·老周',
    tags: ['颁奖礼名场面', '老照片', '口碑反转'],
    views: 51200,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=dim%20grand%20awards%20ceremony%20theater%20interior%20with%20rows%20of%20empty%20red%20seats%20and%20stage%20spotlight%2C%20archival%20press%20photograph%2C%20warm%20sepia%20tone%2C%20cinematic%20moody%20lighting%2C%20nostalgic%20film%20grain%2C%20no%20text&width=960&height=640&seq=gossip-cover-02&orientation=landscape',
    coverAlt: '旧颁奖礼礼堂空镜',
    body: [
      { type: 'p', text: '那张截图在社交媒体上被转发了无数次，配文永远是同一句："看，果然不高兴。"画面里的艺人面无表情坐在台下，周围的镜头却对准了另一位领奖者。' },
      { type: 'p', text: '可是如果我们愿意多花两分钟，去翻看当晚的完整机位记录，就会发现一个被所有人忽略的细节：他的名牌被贴在了别人的座位上，而他全程只是在安静等待工作人员调整。' },
      { type: 'h', text: '一个座位牌引发的十年误读' },
      { type: 'p', text: '现场导播的切换脚本显示，当主持人口播到相关名单时，导播本应切到他反应的特写镜头。但因为座位调整导致的慌乱，镜头最终给了空镜头和另一位嘉宾。于是，一个单纯的调度失误，被舆论脑补成了"关系不和的实锤"。' },
      { type: 'list', items: ['原始机位中他多次微笑鼓掌，只是未被剪辑进主信号；', '同场多位艺人的名牌同样被贴错，现场一度混乱；', '次年同平台再办典礼，他的团队专程提前确认座位。'] },
      { type: 'q', text: '考古的乐趣，就是愿意在别人只看一眼的地方，多停下来看第二眼。', by: '档案员手记' },
      { type: 'p', text: '这条旧瓜的真正价值不在于"洗白"，而在于提醒我们：在网络时代，一张截图的解释权，永远不该被轻易交给几秒钟的动态。' },
    ],
  },
  {
    id: 3,
    title: '尘封的录音带：那位歌后隐退前，最后一张未发行专辑的秘密',
    category: '历史爆料',
    excerpt:
      '一张被锁在档案柜里二十年的母带，牵出这位传奇歌后急流勇退的完整脉络。我们从制作人当年的工作笔记里，找到了从未公开的答案。',
    date: '2025-08-20',
    readTime: '10 分钟',
    author: '考据派·闻笛',
    tags: ['幕后制作', '老照片', '记者手记'],
    views: 38600,
    cover:
      'https://readdy.ai/api/search-image?query=old%20reel%20to%20reel%20tape%20and%20vintage%20recording%20microphone%20on%20a%20wooden%20studio%20desk%2C%20warm%20dusty%20light%2C%20archival%20music%20history%20photograph%2C%20aged%20sepia%20tone%2C%20nostalgic%20film%20grain%2C%20no%20text&width=960&height=640&seq=gossip-cover-03&orientation=landscape',
    coverAlt: '录音室里的旧母带与麦克风',
    body: [
      { type: 'p', text: '在很多乐迷的记忆里，那位歌后的隐退干脆得近乎决绝：前一年还在巡回，后一年就再无公开活动。江湖上流传着各种说法，却没有一种被当事人亲自印证。' },
      { type: 'h', text: '制作人工作笔记里的三页纸' },
      { type: 'p', text: '我们找到的制作人笔记显示，歌后其实已经完成了新专辑过半的录制。笔记里反复出现同一句话："她想要的不只是被听见，而是被听懂。"这或许才是问题的核心。' },
      { type: 'p', text: '随着唱片公司被收购、制作团队解散，这批母带和笔记一同被归入档案柜，再也没有被提起。歌后本人此后转向幕后，将许多新人送上舞台。' },
      { type: 'q', text: '她只是换了一种方式唱歌——把麦克风递给了更年轻的声音。', by: '当年制作人回忆' },
      { type: 'p', text: '如今再听那些流出的试唱片段，许多人感叹：原来她的巅峰，比我们以为的更早到来，也更深沉。这段尘封往事的意义，不在八卦本身，而在于一个创作者对自我价值的清醒选择。' },
    ],
  },
  {
    id: 4,
    title: '旧事重提：当年全网群嘲的那条微博，为何今天被当成了预言',
    category: '旧事重提',
    excerpt:
      '八年前那条被做成表情包嘲笑了无数遍的动态，如今被网友翻出来直呼"神预言"。旧事重提不是打脸，而是时间给了我们重新读它的资格。',
    date: '2025-07-28',
    readTime: '7 分钟',
    author: '编辑部·大川',
    tags: ['舆论往事', '翻车现场', '口碑反转'],
    views: 60400,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=close%20up%20of%20an%20old%20smartphone%20and%20printed%20tweets%20on%20aged%20paper%2C%20warm%20desk%20lamp%20light%2C%20archival%20media%20history%20photograph%2C%20sepia%20vintage%20mood%2C%20no%20text&width=960&height=640&seq=gossip-cover-04&orientation=landscape',
    coverAlt: '旧手机与打印微博纸条',
    body: [
      { type: 'p', text: '互联网是有记忆的，这句话在最近又一次应验。当某位艺人多年来的选择逐步被验证时，网友不约而同地想起了八年前那条被做成表情包的微博。' },
      { type: 'p', text: '当年评论区的画风几乎一边倒，要么觉得他在嘴硬，要么觉得他在炒作。谁能想到，八年后的现实会以近乎复刻的方式，证明了那条动态里的每一句话。' },
      { type: 'h', text: '旧事重提的正确姿势' },
      { type: 'p', text: '有人把这种反转称为"预言成真"，但在我们看来，它更接近一次真诚的自我坚持被时间正名。旧事重提的意义，从来不是猎奇地翻旧账，而是把当年的判断放进今天的坐标系里重新校准。' },
      { type: 'list', items: ['当年的否定声音，多少来自对行业周期的误判；', '被嘲讽的"固执"，其实是基于长期主义的坚持；', '今天的读者，恰好拥有了回看完整叙事的视角。'] },
      { type: 'q', text: '时间是最公平的评论家，它从不为流量站队。', by: '编辑部' },
      { type: 'p', text: '所以下次再看到某条"旧事重提"冲上热搜时，不妨先放下表情包，认真把当年的上下文读一遍——真相往往藏在时间线的起点。' },
    ],
  },
  {
    id: 5,
    title: '当年真相：一则"陪酒传闻"为何十年来始终无法被证伪',
    category: '当年真相',
    excerpt:
      '一条来源不明的传闻，历经十年仍在传播。我们顺着最早的帖子一路溯源，发现这则八卦的"第一现场"，其实只是一张被误读的老照片。',
    date: '2025-06-15',
    readTime: '9 分钟',
    author: '真相组·青梧',
    tags: ['绯闻澄清', '旧访谈', '记者手记'],
    views: 33600,
    cover:
      'https://readdy.ai/api/search-image?query=stack%20of%20old%20newspapers%20and%20faded%20photographs%20on%20an%20archive%20desk%20with%20magnifying%20glass%2C%20warm%20dusty%20research%20room%2C%20archival%20journalism%20photograph%2C%20sepia%20toned%2C%20nostalgic%2C%20no%20text&width=960&height=640&seq=gossip-cover-05&orientation=landscape',
    coverAlt: '堆满旧报纸与老照片的考据桌',
    body: [
      { type: 'p', text: '在中文互联网的八卦语料库里，有些传闻像牛皮糖一样甩不掉。"陪酒传闻"就是其中最典型的案例：它没有当事人、没有目击者，甚至连一张正经的照片都没有，却顽强地传播了十年。' },
      { type: 'h', text: '顺着帖子的来路一路回溯' },
      { type: 'p', text: '我们把这条传闻最早出现的帖子时间、配图和转发路径全部拉了出来。真相令人哭笑不得：一切的源头，是一张被掐头去尾的老照片，照片里的场景不过是某次普通的杀青宴。' },
      { type: 'p', text: '而当谣言进入"口口相传"阶段后，每一次复述都会添上新细节，最后连最初发帖的人都认不出自己当初的说法。' },
      { type: 'list', items: ['原始照片发布于某剧组的公开探班报道；', '被裁剪后，画面语义被完全改写；', '反复转述让"传闻"获得了"多人印证"的假象。'] },
      { type: 'q', text: '追证伪的过程，往往比瓜本身更值得记录。', by: '真相组' },
      { type: 'p', text: '这条当年真相告诉我们：当一条八卦永远"查无实据"时，它最大的价值，恰恰是我们愿意停下来追问它到底从哪里来。' },
    ],
  },
  {
    id: 6,
    title: '考古重读：那档停播十年的综艺，为何成为一代人的白月光',
    category: '考古重读',
    excerpt:
      '当人们反复用"真诚""有温度"去怀念一档老综艺时，我们扒开当年的制作花絮，找到了它至今无法被复制的核心密码。',
    date: '2025-05-30',
    readTime: '8 分钟',
    author: '档案员·阿菁',
    tags: ['综艺考古', '幕后制作', '旧访谈'],
    views: 45800,
    cover:
      'https://readdy.ai/api/search-image?query=empty%20retro%20TV%20studio%20set%20with%20stage%20lights%20and%20old%20cameras%2C%20warm%20golden%20stage%20glow%2C%20archival%20television%20history%20photograph%2C%20sepia%20nostalgic%20mood%2C%20film%20grain%2C%20no%20text&width=960&height=640&seq=gossip-cover-06&orientation=landscape',
    coverAlt: '老综艺录影棚空镜',
    body: [
      { type: 'p', text: '每到某个节点，社交平台就会集体刷起那档综艺的片段。弹幕里最常见的词是"回不去了"，其次是"原来当年的综艺可以这么真诚"。' },
      { type: 'h', text: '真诚，其实是最高级的脚本' },
      { type: 'p', text: '翻看当年的制作记录，我们惊讶地发现：这档节目几乎没有"剧本"，导演组坚持让嘉宾在镜头前说出真实想法，哪怕剪辑时再难处理。"我们宁愿播出时冷场三秒，也不要一句假的感动。"这是制作人当时反复强调的一句话。' },
      { type: 'p', text: '在算法追求高能反转的今天回看，那种允许沉默、允许嘉宾"真实地不那么有趣"的勇气，反而成了最稀缺的东西。' },
      { type: 'q', text: '观众不是不爱看综艺了，而是太想念那种没有被安排好的意外。', by: '老导演访谈' },
      { type: 'p', text: '考古的意义正在于此：当我们重新打开那档旧节目，真正被打动的，是其中那份如今越来越少见的不设防。' },
    ],
  },
  {
    id: 7,
    title: '春晚旧闻：那年临时被换下的节目，幕后经历了怎样的十小时',
    category: '历史爆料',
    excerpt:
      '一段尘封的导演组日志，还原了那届春晚最惊心动魄的十小时：从联排到直播，一个节目如何在最后一刻完成"生死时速"般的调整。',
    date: '2025-04-10',
    readTime: '7 分钟',
    author: '考据派·闻笛',
    tags: ['春晚旧闻', '幕后制作', '记者手记'],
    views: 29800,
    cover:
      'https://readdy.ai/api/search-image?query=backstage%20of%20a%20grand%20gala%20with%20cluttered%20headsets%20and%20monitors%2C%20red%20lanterns%20dimly%20lit%20in%20distance%2C%20archival%20festival%20television%20photograph%2C%20warm%20sepia%2C%20no%20text&width=960&height=640&seq=gossip-cover-07&orientation=landscape',
    coverAlt: '晚会后台导播台',
    body: [
      { type: 'p', text: '在许多人关于春晚的记忆里，这台晚会似乎是"准时、工整、不容出错"的代名词。但一段被封存的导演组日志，揭示了它最紧张的一面。' },
      { type: 'h', text: '直播前夜的不眠会议' },
      { type: 'p', text: '日志显示，某届春晚在正式直播前的十小时里，经历了一次牵动全场的节目调整。原因并非内容问题，而是一次意外的时间超支和一次临时的串联变动。' },
      { type: 'p', text: '从重新编排串联词、协调相邻节目站位，到灯光、音响、导播、字幕四个工种同步改cue，整个后台像一台高速运转的精密仪器。最终，直播准时结束，观众几乎没有察觉任何异样。' },
      { type: 'q', text: '完美的背后，是把每一个"万一"都提前想过的十小时。', by: '当年副导演回忆' },
      { type: 'p', text: '如今再回看这段历史爆料，我们看到的不是戏剧性的翻车，而是一群幕后工作者用专业守护一场团圆直播的动人细节。' },
    ],
  },
  {
    id: 8,
    title: '旧事重提：曾被骂"没有代表作"的演员，靠一封信完成了口碑长线翻盘',
    category: '旧事重提',
    excerpt:
      '十年前的他被贴上"综艺咖""没作品"标签，十年后一部冷门佳作让他封神。旧事重提之下，我们看到的是一段关于蛰伏与耐心的叙事。',
    date: '2025-03-22',
    readTime: '6 分钟',
    author: '编辑部·大川',
    tags: ['口碑反转', '舆论往事', '老照片'],
    views: 37900,
    cover:
      'https://readdy.ai/api/search-image?query=old%20typewriter%20with%20a%20handwritten%20letter%20and%20film%20clapperboard%20on%20a%20warm%20desk%2C%20archival%20cinema%20history%20photograph%2C%20sepia%20toned%2C%20nostalgic%20drama%2C%20no%20text&width=960&height=640&seq=gossip-cover-08&orientation=landscape',
    coverAlt: '打字机、手写信与场记板',
    body: [
      { type: 'p', text: '翻看他早年的评论区，几乎被同一个声音占据："这个人除了搞笑，还会什么？"没有人为他辩护，因为彼时连他自己都没有拿得出手的作品来回应。' },
      { type: 'p', text: '直到那部几乎没有宣发经费的冷门剧播出，所有人突然意识到：他这些年不是在混日子，而是一直在给自己攒底牌。' },
      { type: 'h', text: '一封信里的长线主义' },
      { type: 'p', text: '剧集播出后，一封他早年间写给自己的信被公开。信里没有豪言壮语，只有一句朴素的自我提醒："别急着证明给别人看，先把活干扎实。"这或许正是他口碑翻盘的最好注脚。' },
      { type: 'q', text: '流量会过期，但作品会替你把话说下去。', by: '网友高赞评论' },
      { type: 'p', text: '旧事重提的价值，在于它给了我们一个更长的观察窗口：很多被嘲笑的坚持，只是在等待一个合适的播出档期。' },
    ],
  },
  {
    id: 9,
    title: '当年真相：那些流传至今的"圈内黑话"，真正指的是什么',
    category: '当年真相',
    excerpt:
      '从"头套""送审""剪一版"到"养号""买热搜"，娱乐圈黑话背后是一整套外人看不见的产业语言。我们替你逐条翻译。',
    date: '2025-02-18',
    readTime: '9 分钟',
    author: '真相组·青梧',
    tags: ['幕后制作', '舆论往事', '旧访谈'],
    views: 27500,
    cover:
      'https://readdy.ai/api/search-image?query=glossary%20notebook%20with%20fountain%20pen%20next%20to%20stacked%20old%20film%20reels%2C%20warm%20study%20desk%2C%20archival%20media%20research%20photograph%2C%20sepia%20toned%2C%20no%20text&width=960&height=640&seq=gossip-cover-09&orientation=landscape',
    coverAlt: '词典笔记与旧胶片',
    body: [
      { type: 'p', text: '混迹过饭圈和八卦区的读者，大概都听过一些云里雾里的"圈内黑话"。它们像一层密语，把局外人挡在门外，也让很多旧瓜显得扑朔迷离。' },
      { type: 'h', text: '黑话背后的产业切片' },
      { type: 'p', text: '其实大多数黑话并不神秘，它们只是这个行业在长期运转中沉淀下来的"行话"。理解了它们，很多看似匪夷所思的八卦逻辑就会瞬间清晰。' },
      { type: 'list', items: ['"剪一版"：指根据舆情或送审要求重新剪辑成片；', '"头套"：指为规避审核风险而做的提前预处理；', '"养号"：指通过长期发布内容积累账号权重；', '"锁热搜"：指在特定时段集中投放话题词。'] },
      { type: 'q', text: '当一个行业开始频繁使用暗语时，恰恰说明它需要被更多局外人了解。', by: '真相组' },
      { type: 'p', text: '翻译这些黑话，并不是为了让人更"懂行"，而是为了减少信息差带来的误读——这是考古重读最朴素的价值。' },
    ],
  },
  {
    id: 10,
    title: '陈年旧瓜：世纪之交的那场"双玉之争"，究竟争的是什么',
    category: '陈年旧瓜',
    excerpt:
      '二十多年前，两位女演员的"争番""抢角"传闻闹得满城风雨。多年后当事人都已放下，可我们依然好奇：那场争执的实质到底是什么？',
    date: '2025-01-05',
    readTime: '8 分钟',
    author: '档案员·阿菁',
    tags: ['颁奖礼名场面', '绯闻澄清', '口碑反转'],
    views: 52300,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=two%20vintage%20film%20posters%20leaning%20against%20each%20other%20by%20a%20warm%20window%20light%2C%20archival%20cinema%20history%20photograph%2C%20sepia%20golden%20mood%2C%20nostalgic%2C%20no%20text&width=960&height=640&seq=gossip-cover-10&orientation=landscape',
    coverAlt: '两张并排的旧电影海报',
    body: [
      { type: 'p', text: '在很多老影迷的叙事里，"双玉之争"被简化为一场你死我活的资源厮杀。但实际上，那几年她们的戏路、受众和商业定位，本就走着截然不同的两条路。' },
      { type: 'h', text: '被媒体放大的竞争' },
      { type: 'p', text: '当年的杂志和电视报道热衷于制造"宿敌感"：同一场颁奖礼、同一档访谈，都会被剪成暗中较劲的戏码。可当舆论的高潮退去，两位当事人之间的关系，其实远没有外界想象的剑拔弩张。' },
      { type: 'p', text: '多年后其中一位在采访中坦言："我们被安排成对手，但观众真正想看的是好作品。我和她只是恰好同一年代、同样努力，仅此而已。"' },
      { type: 'q', text: '时代需要对手戏，却常常把旗鼓相当误写成势不两立。', by: '编者按' },
      { type: 'p', text: '把这场旧瓜放回当年的产业语境，它更像是一次媒体叙事的示范案例：真正的演员之争从不在红毯上，而在银幕里。' },
    ],
  },
  {
    id: 11,
    title: '考古重读：那封被营销号转了十年的"分手信"，笔迹鉴定后推翻了什么',
    category: '考古重读',
    excerpt:
      '一封据说出自某位艺人之手的"分手信"在坊间流传多年。当考据派动用最笨的方法逐字比对后，发现了一个被忽略多年的真相。',
    date: '2024-12-11',
    readTime: '7 分钟',
    author: '资料员·老周',
    tags: ['绯闻澄清', '老照片', '舆论往事'],
    views: 34800,
    cover:
      'https://readdy.ai/api/search-image?query=handwritten%20letter%20pages%20under%20a%20warm%20desk%20lamp%20with%20an%20old%20magnifying%20glass%20and%20inkwell%2C%20archival%20document%20investigation%20photograph%2C%20sepia%20toned%2C%20mysterious%20vintage%20mood%2C%20no%20text&width=960&height=640&seq=gossip-cover-11&orientation=landscape',
    coverAlt: '台灯下的手写信与放大镜',
    body: [
      { type: 'p', text: '如果说娱乐圈有什么东西最经得起"考古"，那一定是那些流传多年、却始终找不到原始出处的手写信件。这封"分手信"就是典型代表。' },
      { type: 'p', text: '十年来，它被无数八卦账号引用，每一次都会配上"独家曝光"的字样。可当我们想去找它的"第一次出现"时，却始终只能追溯到某个营销号的转载页。' },
      { type: 'h', text: '最笨的考据方法' },
      { type: 'p', text: '面对没有原始档案的情况，考据派决定用最笨却最有效的方法：把这封信的措辞、用纸、标点习惯，和那位艺人公开的亲笔字迹一一比对。结果发现，两者在多处关键特征上存在明显出入。' },
      { type: 'p', text: '换言之，这封被传播了十年的信，极可能从一开始就是一篇没有署名出处、却被不断"证实"的都市传说。' },
      { type: 'q', text: '越是传播久远的"实锤"，越值得被问一句：它的第一现场，到底在哪里？', by: '资料室' },
      { type: 'p', text: '考古重读教会我们一件事：判断一条八卦的真伪，很多时候不需要高深的技术，只需要愿意多花一点时间去追它的源头。' },
    ],
  },
  {
    id: 12,
    title: '历史爆料：选秀一夜成名后，那批"素人冠军"为何集体转向',
    category: '历史爆料',
    excerpt:
      '十年间，十余位选秀冠军走出荧幕，却鲜有人真正站在流量之巅。当我们梳理他们的职业轨迹，看见了一条被包装遮蔽的真实路径。',
    date: '2024-11-03',
    readTime: '8 分钟',
    author: '编辑部·大川',
    tags: ['选秀考古', '旧访谈', '记者手记'],
    views: 29100,
    cover:
      'https://readdy.ai/api/search-image?query=old%20stage%20spotlight%20with%20silhouette%20of%20a%20single%20performer%20holding%20a%20microphone%20stand%2C%20warm%20backlight%2C%20archival%20music%20history%20photograph%2C%20sepia%20dramatic%20mood%2C%20film%20grain%2C%20no%20text&width=960&height=640&seq=gossip-cover-12&orientation=landscape',
    coverAlt: '舞台追光下的单人剪影',
    body: [
      { type: 'p', text: '选秀造星的故事听起来总是热血：一个普通人站上舞台，一夜之间被数百万人记住。但如果把时间轴拉长十年，那条"一夜成名"的路，远比想象中复杂。' },
      { type: 'h', text: '被掩盖的行业真相' },
      { type: 'p', text: '我们梳理了十余位素人冠军的职业档案，发现他们中的大多数，最终都转向了直播、音乐制作或线下演出等更"接地气"的方向。' },
      { type: 'p', text: '这并非失败，而是一种清醒。当单一平台的流量红利退潮，能够存活下来的，往往是那些把"冠军"头衔转化为可持续职业能力的人。' },
      { type: 'list', items: ['流量是把双刃剑，来得快去得也快；', '真正的职业生命，靠的是不可替代的专业能力；', '告别"冠军光环"，反而让他们找到了更长久的表达方式。'] },
      { type: 'q', text: '一夜成名的故事让人着迷，可让人走得更远的，永远是之后的无数个夜晚。', by: '编辑部' },
      { type: 'p', text: '这段历史爆料的意义，在于让我们对"选秀神话"保持一份清醒的敬意——既不神话那一夜，也不轻视他们之后的每一次转身。' },
    ],
  },
  {
    id: 13,
    title: '旧事重提：当年被嘲"过气"的老牌歌手，如何靠一场演唱会翻红',
    category: '旧事重提',
    excerpt:
      '在流量为王的日子里，"过气"几乎成了原罪。可那位被贴上标签多年的歌手，却用一场不打折的现场，重新定义了什么叫真正的"红"。',
    date: '2024-10-16',
    readTime: '6 分钟',
    author: '考据派·闻笛',
    tags: ['口碑反转', '旧访谈', '幕后制作'],
    views: 41200,
    cover:
      'https://readdy.ai/api/search-image?query=vintage%20arena%20concert%20crowd%20silhouettes%20with%20stage%20lights%20in%20warm%20sepia%20tones%2C%20archival%20music%20history%20photograph%2C%20nostalgic%20electric%20mood%2C%20no%20text&width=960&height=640&seq=gossip-cover-13&orientation=landscape',
    coverAlt: '老牌歌手演唱会现场剪影',
    body: [
      { type: 'p', text: '在一个数据可以随时被"充气"的时代，"过气"二字显得格外刺耳。它似乎默认了：没有流量，就等于没有价值。' },
      { type: 'h', text: '不打折的现场是最好的辟谣' },
      { type: 'p', text: '那场演唱会没有任何花哨的营销，甚至没有大面积买热搜。可当全场上万人合唱到最后一首老歌时，所有关于"过气"的质疑都自动消散了。' },
      { type: 'p', text: '他并没有翻红到顶流的高度，也无意如此。他只是用两小时证明了：有些作品的保质期，远远长于算法给你的一生。' },
      { type: 'q', text: '所谓翻红，其实只是把沉淀多年的本事，重新亮给愿意听的人看。', by: '现场观众手记' },
      { type: 'p', text: '旧事重提到最后，我们往往会发现：那些曾经被轻慢的坚持，终会在某个合适的夜晚，用最朴素的现场回应所有疑问。' },
    ],
  },
  {
    id: 14,
    title: '当年真相：综艺"剧本说"甚嚣尘上，剪辑到底背了多少锅',
    category: '当年真相',
    excerpt:
      '每当综艺出现反转，弹幕就会刷起"有剧本"。但真相远比一句"剧本"复杂——我们拆解了从拍摄到播出的完整链路。',
    date: '2024-09-20',
    readTime: '8 分钟',
    author: '真相组·青梧',
    tags: ['综艺考古', '幕后制作', '翻车现场'],
    views: 38600,
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20timeline%20screen%20and%20clapperboard%20with%20rows%20of%20footage%2C%20warm%20editing%20room%20light%2C%20archival%20television%20production%20photograph%2C%20sepia%20mood%2C%20no%20text&width=960&height=640&seq=gossip-cover-14&orientation=landscape',
    coverAlt: '剪辑室中的时间线画面与场记板',
    body: [
      { type: 'p', text: '看综艺时，观众最爱喊的一句话莫过于"这剧本也太明显了"。但如果我们真的走进剪辑室，就会明白"剧本"二字远不能概括一档综艺的真实运作。' },
      { type: 'h', text: '赛制、人设与剪辑的三方博弈' },
      { type: 'p', text: '一档真人秀的"好看"，往往是赛制设计、嘉宾表现与后期叙事三方共同作用的结果。赛制会预设冲突的可能，后期会放大情绪的瞬间，但嘉宾真实的临场反应，才是任何剪辑都无法凭空制造的核心。' },
      { type: 'list', items: ['赛制决定"能发生什么"；', '嘉宾的真实反应决定"发生了什么"；', '剪辑决定"让观众看到什么"。'] },
      { type: 'q', text: '没有一档爆款综艺能靠纯剧本走红，因为观众对"假"的容忍度，远比想象的更低。', by: '老剪辑师' },
      { type: 'p', text: '理解了这条链路，再回看那些"剧本说"的争议，就会多一层理性的视角：真正的综艺魅力，恰恰在于真实与叙事之间那一点点不可控的缝隙。' },
    ],
  },
];

export const hotArticles = [
  articles.find((a) => a.id === 4)!,
  articles.find((a) => a.id === 2)!,
  articles.find((a) => a.id === 10)!,
  articles.find((a) => a.id === 1)!,
  articles.find((a) => a.id === 13)!,
  articles.find((a) => a.id === 6)!,
];

export const getCategoryArticles = (slug: string) => {
  const map: Record<string, string> = {
    'chennian-gua': '陈年旧瓜',
    'kaogu-chongdu': '考古重读',
    'lishi-baoliao': '历史爆料',
    'jiushi-chongti': '旧事重提',
    'dangnian-zhenxiang': '当年真相',
  };
  const name = map[slug];
  return { name, list: name ? articles.filter((a) => a.category === name) : articles };
};